module.exports = __webpack_public_path__ + "static/media/subBanner.027365a4.png";